/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {BookOfShadows} from "../../BookOfShadows";
import {BookOfShadowsGameConfig} from "../../BookOfShadowsGameConfig";
import {BookOfShadowsGameModuleConfig} from "../../BookOfShadowsGameModuleConfig";
import {SoundManager} from "../../sound/SoundManager";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {BookOfShadowsReelController} from "../../reel/BookOfShadowsReelController";

export class ReelStart implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private readonly _reelId: number;

    /**
     * @constructs
     * @param reelId
     * @param stagger
     * @param abortStagger
     */
    constructor(reelId: number, stagger?: number, abortStagger?: number) {
        this._reelId = reelId;
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: ParsedServerData): Timeline | null {
        // no need to spin a locked reel.
        if (BookOfShadowsGameConfig.instance.LOCKED_REEL[this._reelId] === "1") {
            Reels.getReel(this._reelId)!.startSpin({active:false, fastSpin:false},0);
            return null;
        }

        if (this._reelId === (BookOfShadowsGameConfig.instance.LOCKED_REEL.indexOf("0"))) {
            const rowDiff: number = (5 - BookOfShadowsGameConfig.instance.ACTIVE_ROWS);
            let scatterCount: number = 0;
            for (let i: number = 0; i < BookOfShadowsGameConfig.instance.LOCKED_REEL.length; i++) {
                if (BookOfShadowsGameConfig.instance.LOCKED_REEL[i] === "1" && BookOfShadowsGameConfig.instance.SCATTER_REEL_ID[i] && BookOfShadowsGameConfig.instance.SCATTER_REEL_SYM_ID[i] >= rowDiff) {
                    scatterCount++;

                    if (scatterCount === 2) {
                        BookOfShadowsGameModuleConfig.nearWinView.playAnimation(this._reelId);

                        if (!BookOfShadowsGameConfig.instance.ANTICIPATION_SOUND_PLAYED) {
                            SoundManager.playAnticipation();
                            BookOfShadowsGameConfig.instance.ANTICIPATION_SOUND_PLAYED = true;
                        }

                        this.changeStateForScatter(BookOfShadowsGameConfig.instance.SCATTER_REEL_ID.lastIndexOf(true));

                        break;
                    }
                } else {
                    BookOfShadowsGameConfig.instance.SCATTER_REEL_ID[i] = false;
                    BookOfShadowsGameConfig.instance.SCATTER_REEL_SYM_ID[i] = -1;
                }
            }

            BookOfShadowsGameConfig.instance.SCATTER_COUNT = scatterCount;
        }

        return BookOfShadows.timelineReelsController.startSpin(this._reelId);
    }

    /**
     * @description To changes the state of scatter symbol w.r.t. anticipation.
     * @param lastReelId
     */
    private changeStateForScatter(lastReelId: number): void {
        const sAnticipationState: ISymbolStateConfig = BookOfShadowsGameConfig.instance.SYMBOL_STATES.sAnticipation;

        for (let i = 0; i <= lastReelId; i++) {
            (Reels.getReel(i) as BookOfShadowsReelController).changeStateForScatter(sAnticipationState);
        }
    }
}